export default __webpack_public_path__ + "static/media/12.0f4d95fc.jpg";